<div class="como-funciona-container black-panel" id="como-funciona" #rootElement>
    <div class="container">
        <div class="row">
            <div class="col-4">
                <img src="https://api.bealign.com/img/contenidos/11.jpg" class="img-fluid"/>
            </div>
            <div class="col-4">
                <img src="https://api.bealign.com/img/contenidos/12.jpg" class="img-fluid"/>
            </div>
            <div class="col-4">
                <img src="https://api.bealign.com/img/contenidos/13.jpg" class="img-fluid"/>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-4">
                <img src="https://api.bealign.com/img/contenidos/14.jpg" class="img-fluid"/>
            </div>
            <div class="col-4">
                <img src="https://api.bealign.com/img/contenidos/15.jpg" class="img-fluid"/>
            </div>
            <div class="col-4">
                <img src="https://api.bealign.com/img/contenidos/16.jpg" class="img-fluid"/>
            </div>
        </div>
    </div>
</div>